import { formatEnumName, formatEnumValue } from '../../../common';
import { createSchemaStatementHandler } from '../../createSchemaStatementHandler';
export const addEnumStmtInstruction = `
#### Creating enums
- Syntax: \`create enum <enum_name> <value1>[, <value2>];\`
- Example: \`create enum orderStatus created, paid, dispatched, finished, canceled;\``;
export const stmtCreateEnum = ({ enumName, values }) => {
    return `create enum ${enumName} ${values.join(', ')};`;
};
export const stmtForHumanCreateEnum = ({ enumName, values }) => {
    return `Create an enum __${enumName}__ with values __${values.join(', ')}__`;
};
export const createEnumHandler = createSchemaStatementHandler({
    type: 'add enum',
    parse: line => {
        const match = /^(add|create) enum (?<enumName>[\w_]+) (?<values>[\w, ]+)/.exec(line);
        return match?.groups
            ? {
                type: 'add enum',
                enumName: formatEnumName(match.groups.enumName),
                values: match.groups.values.split(', ').map(value => formatEnumValue(value)),
            }
            : null;
    },
    getHumanStmt: stmtForHumanCreateEnum,
    apply: (stmt, builder) => {
        builder.updateSchema(it => it.addEnum(stmt));
    },
});
//# sourceMappingURL=CreateEnumStmt.js.map